var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.234.836a.8.8 0 0 1 1.132 0L4 3.47 6.634.836a.8.8 0 1 1 1.132 1.131l-3.2 3.2a.8.8 0 0 1-1.132 0l-3.2-3.2a.8.8 0 0 1 0-1.131",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;